jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

$("ul.select-lists").on("click", ".init", function() {
    $(this).closest("ul.select-lists").children('li:not(.init)').toggle();
});

var allOptions = $("ul.select-lists").children('li:not(.init)');
$("ul.select-lists").on("click", "li:not(.init)", function() {
    allOptions.removeClass('selected');
    $(this).addClass('selected');
    $("ul.select-lists").children('.init').html($(this).html());
    allOptions.toggle();
});
  
});